import React from "react";

import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import classnames from "classnames";

import { JobType, NotificationTagStatus } from "../../../../../util/enums";
import { NotificationBadgeType } from "../type";

type Props = {
  value?: string;
  backgroundColor?: string;
  textColor?: string;
  align?: string;
  classes?: any;
  badgeType?: NotificationBadgeType;
};

const styles = () => ({
  customBadge: {
    display: "flex",
    alignTtems: "center",
    padding: "2px 8px",
    backgroundColor: (props: { textColor?: string; backgroundColor?: string }) =>
      props?.backgroundColor,
    borderRadius: "4px",
    marginLeft: "8px",
  },
  textValue: {
    color: (props: { textColor?: string }) => props?.textColor,
    fontFamily: "Manrope",
    fontSize: "10px",
    fontWeight: 600,
    lineHeight: "20px",
  },
});

const badgeAlignToCenter = makeStyles(() => ({
  badgeAlign: {
    textAlign: "center",
  },
}));

const SimpleBadge = (props: Props) => {
  const { classes, value } = props;
  const clasz = badgeAlignToCenter();

  return (
    <div className={classnames(clasz.badgeAlign, classes.customBadge)}>
      <span className={classes.textValue}>{value}</span>
    </div>
  );
};

const StyledBadge = withStyles(styles)(SimpleBadge);

const NotificationBadge = (props: Props) => {
  const { value, badgeType } = props;

  const renderBadge = (backgroundColor: string, textColor: string, value?: string) => {
    if (value)
      return <StyledBadge backgroundColor={backgroundColor} textColor={textColor} value={value} />;

    return <> </>;
  };

  switch (value?.toLowerCase()) {
    case JobType.IMPORT.toLowerCase():
      return renderBadge("#e7effd", "#5D92F4", value);
    case JobType.EXPORT.toLowerCase():
      return renderBadge("#fdf0e7", "#F18E47", value);
    case JobType.STORAGE.toLowerCase():
      return renderBadge("#d1d4e0", "#464D69", value);
    case JobType.TOLL.toLowerCase():
      return renderBadge("#e7effd", "#5D92F4", value);
    case JobType.FINE_ART.toLowerCase():
      return renderBadge("#fff9e6", "#ffc000", value);
    case JobType.GBS.toLowerCase():
      return renderBadge("#ffe6f2", "#FF69B4", value);
    case JobType.INTERSTATE_JOBS.toLowerCase():
      return renderBadge("#d1d4e0", "#464D69", value);
    case JobType.INTERSTATE.toLowerCase():
      return renderBadge("#d1d4e0", "#464D69", value);
    case JobType.LOCAL.toLowerCase():
      return renderBadge("#e8e7fd", "#8683F6", value);
    case JobType.COUNTRY_REMOVAL.toLowerCase():
      return renderBadge("#e6ffe8", "#00D014", value);
    case JobType.LONG_DISTANCE.toLowerCase():
      return renderBadge("#cccccc", "#727272", value);
    case JobType.STORE_OUT.toLowerCase():
      return renderBadge("#d1d4e0", "#464D69", value);

    case NotificationTagStatus.NEW.toLowerCase():
    case NotificationTagStatus.APPROVED.toLowerCase():
      return renderBadge("#D1FADF", "#039855", value);
    case NotificationTagStatus.DECLINED.toLowerCase():
      return renderBadge("#FEE4E2", "#D92D20", value);
    case NotificationTagStatus.CANCELLED.toLowerCase():
      return renderBadge("#FEE4E2", "#D92D20", value);
    case NotificationTagStatus.UPDATED.toLowerCase():
      return renderBadge("#F4EBFF", "#7F56D9", value);
    default:
      if (badgeType === NotificationBadgeType.TAG) {
        return renderBadge("#E0F2FE", "#0086C9", value);
      }

      return renderBadge("#d1d4e0", "#464D69", value);
  }
};

export default NotificationBadge;
